import Link from 'next/link'
import { Badge } from '~/components/ui/catalyst/badge'
import { cn } from '~/lib/utils'

interface LinkWrapperProps {
  className?: string
  href: string
  children: React.ReactNode
  openInNewTab?: boolean
}

export function LinkWrapper(props: LinkWrapperProps) {
  return (
    <Link
      href={props.href}
      className={cn(
        `flex rounded-xl transition-shadow duration-200 ease-in-out hover:ring-2 hover:ring-sky-500`,
        props.className,
      )}
      target={props.openInNewTab ? '_blank' : undefined}
      rel={props.openInNewTab ? 'noopener' : undefined}
    >
      {props.children}
    </Link>
  )
}

interface FeatureCardProps {
  className?: string
  background: React.ReactNode
  title: string
  description: string
  titleChromaTextAnimate?: boolean
}

export function FeatureCard({ ref, ...props }: FeatureCardProps & { ref?: React.RefObject<HTMLElement | null> }) {
  return (
    <section
      ref={ref}
      className={cn(`relative flex flex-col overflow-hidden rounded-xl border bg-white`, props.className)}
    >
      <div className="pointer-events-none relative z-0 h-64 w-full">{props.background}</div>

      <div className="relative z-1 flex flex-col gap-2 p-4 pt-0 sm:p-8 sm:pt-0">
        <div className="flex items-center gap-2">
          <h3
            className={cn('text-xl font-semibold', props.titleChromaTextAnimate && `chroma-text chroma-text-animate`)}
          >
            {props.title}
          </h3>
          <span className="mt-0.5 inline-flex size-fit rounded-md bg-white">
            <Badge color="orange">Скоро</Badge>
          </span>
        </div>
        <p className="text-pretty text-muted-foreground">{props.description}</p>
      </div>

      <div className={`
        absolute inset-x-0 bottom-0 z-0 size-full bg-gradient-to-t from-white/65 from-35% via-white/20 to-transparent
        dark:from-black/80 dark:via-black/20
      `}
      />
    </section>
  )
}

FeatureCard.displayName = 'FeatureCard'
